export default __webpack_public_path__ + "static/gm-b1c510810c87f15a83863abd6f473e26.jpeg";